var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.state !== "NOT_AVAILABLE"
        ? _c(
            "router-link",
            {
              staticClass: "d-inline-flex align-items-center flex-wrap gap-2",
              attrs: { to: _vm.link },
            },
            [
              _c(
                "UiBadge",
                { attrs: { type: _vm.badge.type, title: _vm.badge.label } },
                [
                  _c("i", { staticClass: "fa-lg", class: _vm.badge.icon }),
                  _vm._v(" "),
                  !_vm.isCompact
                    ? _c("span", [_vm._v(_vm._s(_vm.badge.label))])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.name && !_vm.isCompact
                ? _c("span", [
                    _c("i", { staticClass: "fa fa-bullhorn" }),
                    _vm._v("\n      " + _vm._s(_vm.name) + "\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.name && !_vm.isCompact
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("device.monitoring_status.no_procedure")
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }